import io from 'socket.io-client';
import ObjectData from "../dataModel/ObjectData";
import CookieManager from "./CookieManager";


export default class ServerManager {

    constructor(address) {
        this._socket = io(address, {secure: true});
        this.address = address;

        this.connecting = new Promise((resolve) => {
            this._socket.on('connect', () => {
                //console.log('connected');
                this.isConnected = true;
                resolve(true);
            });
        });
    }

    static productiveServer = 'https://admin.explainitapp.com:36145';
    static sandboxServer = 'https://adminsb.explainitapp.com:3000';

    static productiveConnection = new ServerManager(ServerManager.productiveServer);
    static sandboxConnection = new ServerManager(ServerManager.sandboxServer);
    isConnected = false;

    _emitAsync(request, data) {
        return new Promise((resolve) => {
            this._socket.emit(request, data, resolve);
        });
    }

    async getObject(objectId, fromObjectId) {
        if (!this.isConnected) await this.connecting;

        const testerMode = CookieManager.testerMode; // To avoid statistic changing by testers.
        const answer = await this._emitAsync('playGetObject', {objectId, fromObjectId, testerMode});

        return answer.tags
            ? new ObjectData(answer)
            : false;
    }

    async getSoundtrackData(fileId, crop = false) {
        if (!this.isConnected) await this.connecting;
        return await this._emitAsync('playGetSoundtrackData', {fileId, crop});
    }


}